import { render, staticRenderFns } from "./ValidateTaskTable.vue?vue&type=template&id=226e8ba7&scoped=true&lang=html"
import script from "./ValidateTaskTable.vue?vue&type=script&lang=js"
export * from "./ValidateTaskTable.vue?vue&type=script&lang=js"
import style0 from "./ValidateTaskTable.vue?vue&type=style&index=0&id=226e8ba7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226e8ba7",
  null
  
)

export default component.exports